import { CreditHumanFinancingStatus as SharedCreditHumanFinancingStatus } from "../../../ProposalSetup/financing/CreditHumanFinancingStatus"
import { batteryFinancingBundle } from "../battery-financing-bundle"
import type { BatteryFinancingStatusExperienceProps } from "../financing-status-experiences"

/**
 * Credit Human Existing Loan Application status for the Battery financing-status
 * drawer. Uses Battery financing and active-loan activity resources only.
 */
export function CreditHumanFinancingStatus({
  proposalId,
  financing,
}: BatteryFinancingStatusExperienceProps): JSX.Element {
  return (
    <SharedCreditHumanFinancingStatus
      bundle={batteryFinancingBundle}
      proposalId={proposalId}
      financing={financing}
    />
  )
}
